;(function (angular, _) {
  'use strict'

  class SubcontractorListController {
    constructor (
      // Angular
      // Libs
      // Managers
      // Services
      // Const
      // Resolved
      pagination
    ) {
      this.pagination = pagination
    }
  }

  SubcontractorListController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    'pagination'
  ]

  angular.module('kilo.routes.subcontractor.list')
    .controller('SubcontractorListController', SubcontractorListController)
})(window.angular, window._)
